/**
 * Create Project Command
 * 
 * Command for creating new DDD Project models.
 * Includes validation and business rule enforcement.
 */

import { ICommand, BaseCommand } from '@swoft/core';

export interface CreateProjectPayload {
  name: string;
  description?: string;
  domainId: string;
  boundedContextId?: string;
  metadata?: Record<string, any>;
}

export class CreateProjectCommand extends BaseCommand implements ICommand {
  constructor(
    public readonly payload: CreateProjectPayload,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}